import { Component, Input, ChangeDetectorRef } from '@angular/core';
import { APPCONFIG } from '../../../config';
import { Router, NavigationEnd } from '@angular/router';
import { SessionHandler } from '../../../shared/services/session-handler.service';
import { CommonService } from '../../../shared/services/common.service';
import { LayoutService } from '../../../layout/layout.service';
import { HttpService } from '../../../shared/services/http.service';
import { Config, Menu } from './accordion/type';
import { MdDialog } from '@angular/material';
import { dialogComponent } from '../../../dialog/dialog.component';
import { LoaderService } from '../../../loader/loader.service';

@Component({
    selector: 'my-app-sidenav-menu',
    styles: [require('./sidenav-menu.component.scss')],
    template: require('./sidenav-menu.component.html')
})
export class AppSidenavMenuComponent {
    AppConfig;
    options: Config = { multi: false };
    dialogRef;

    menus: Menu[] = [
        {
            name: 'Web Return Tool',
            iconClass: '',
            active: false,
            menuIconName: 'construction',
            id: 'w_r_t',
            submenu: [
                { name: 'Internet Call Booking', url: '#/app/icb/dashboard', submenuIconName: 'call' },
                { name: 'FOC', url: '#/app/foc_dashboard', submenuIconName: 'call' }
            ]
        },
        {
            name: 'Internet Call Booking',
            iconClass: '',
            active: false,
            menuIconName: 'call',
            id: 'i_c_b',
            submenu: [
                { name: 'Web Return Tool', url: '#/app/dashboard', submenuIconName: 'construction' },
                { name: 'FOC', url: '#/app/foc_dashboard', submenuIconName: 'call' }
            ]
        },
        {
            name: 'FOC',
            iconClass: '',
            active: false,
            menuIconName: 'construction',
            id: 'f_o_c',
            submenu: [
                { name: 'Web Return Tool', url: '#/app/dashboard', submenuIconName: 'construction' },
                { name: 'Internet Call Booking', url: '#/app/icb/dashboard', submenuIconName: 'call' }
            ]
        }
    ];

    userData: any;

    isApprover = false;
    isFS = false;
    isAdmin = false;
    isIcb = false;
    isFOC = false;
    isOTD = false;
    isOrderDesk = false;
    allAccess = false;

    // FOC roles
    hasFOCRole = false;
    isFOC_Admin = false;
    isFOC_HR = false;
    isFOC_Approver = false;
    isFOC_Employee = false;
    hasOnlyFOCRole = false;
    isDisplayOnlyUser = false;


    constructor(
        private router: Router,
        public dialog: MdDialog,
        public layoutService: LayoutService,
        public httpService: HttpService,
        public sessionHandler: SessionHandler,
        public commonService: CommonService,
        private LoaderService: LoaderService,
        private ref: ChangeDetectorRef
    ) {
        this.userData = JSON.parse(this.sessionHandler.getItem('loginData'));
        this.allAccess = JSON.parse(this.sessionHandler.getItem('allAccess'));

        const roles: string[] =
            (this.userData && this.userData.role) ? this.userData.role : [];

        // ---- ROLE CHECKS ----
        this.hasFOCRole = roles.some(r => r && r.toUpperCase().indexOf('FOC') !== -1);
        this.isFOC_Admin = roles.indexOf('FOC_ADMINISTRATOR') !== -1;
        this.isFOC_HR = roles.indexOf('FOC_HR') !== -1;
        this.isFOC_Approver = roles.indexOf('FOC_APPROVER') !== -1;
        this.isFOC_Employee = roles.indexOf('FOC_EMPLOYEE') !== -1;
        this.hasOnlyFOCRole = this.commonService.isOnlyFOCRole(roles);
        // OLD ROLE LOGIC
        if (roles.indexOf('APPROVER') !== -1 || roles.indexOf('ADMIN') !== -1) {
            this.isApprover = true;
        }
        if (roles.indexOf('EMPLOYEE') !== -1 || roles.indexOf('ADMIN') !== -1) {
            this.isFS = true;
        }
        if (roles.indexOf('ADMIN') !== -1) {
            this.isAdmin = true;
        }
        if (roles.indexOf('OTD_APPROVER') !== -1) {
            this.isOTD = true;
        }
        if (roles.indexOf('ORDER_DESK_AGENT') !== -1) {
            this.isOrderDesk = true;
        }
        this.isDisplayOnlyUser = roles.length === 1 && roles[0] === 'FOC_DISPLAY';
        if(this.hasOnlyFOCRole){
            this.allAccess = false;
            this.sessionHandler.saveItem('allAccess', false);
        }else if (this.hasFOCRole) {
            // ONLY FOC ROLES GET MULTI APP ACCESS
            this.allAccess = true;
            this.sessionHandler.saveItem('allAccess', true);
        }

        // RESTORE CONTEXT
        this.isIcb = JSON.parse(this.sessionHandler.getItem('isIcb'));
        this.isFOC = this.hasFOCRole ? JSON.parse(this.sessionHandler.getItem('isFOC')) : false;

        const currentUrl = this.router.url || window.location.hash.replace('#', '');

        if (currentUrl.indexOf('/app/foc') === 0 && this.hasFOCRole) {
            this.isFOC = true;
            this.isIcb = false;
        } else if (currentUrl.indexOf('/app/icb') === 0) {
            this.isIcb = true;
            this.isFOC = false;
        } else if (currentUrl.indexOf('/app/dashboard') === 0) {
            this.isIcb = false;
            this.isFOC = false;
        }

        console.log("isFOC -"+this.isFOC+" isICB -"+this.isIcb);
    }

    ngOnInit() {
        this.AppConfig = APPCONFIG;
        this.detectStorageChnges();
        this.detectChangesFOC();

        this.router.events
            .filter(e => e instanceof NavigationEnd)
            .subscribe((e: NavigationEnd) => {
                const url = e.urlAfterRedirects || e.url;

                if (url.indexOf('/app/dashboard') === 0) {
                    this.isIcb = false;
                    this.isFOC = false;
                } else if (url.indexOf('/app/icb/dashboard') === 0) {
                    this.isIcb = true;
                    this.isFOC = false;
                } else if (url.indexOf('/app/foc') === 0 && this.hasFOCRole) {
                    this.isIcb = false;
                    this.isFOC = true;
                }
            });
    }
      

    toggleCollapsedNav() {
        this.AppConfig.navCollapsed = !this.AppConfig.navCollapsed;
    }

    detectStorageChnges() {
        this.sessionHandler.watchStorage().subscribe(() => {
            this.isIcb = JSON.parse(this.sessionHandler.getItem('isIcb'));
        });
    }

    detectChangesFOC() {
        this.sessionHandler.watchStorage().subscribe(() => {
            const flg = JSON.parse(this.sessionHandler.getItem('isFOC'));
            this.isFOC = this.hasFOCRole ? flg : false;
        });
    }

    public newRequest() {
        this.commonService.setData(null);
        this.router.navigate(['/app/requests/create']);
    }

    logout() {
        this.httpService.getRequest('userOperationsApi/v1/logout')
          .subscribe(
            () => {
                this.LoaderService.hide();
                this.sessionHandler.clearAllItems();
              this.router.navigate(['/login']);
            },
            () => {
                this.LoaderService.hide();
              this.sessionHandler.clearAllItems();
              this.router.navigate(['/login']);
            }
          );
      }
      
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/layout/sidenav/sidenav-menu/sidenav-menu.component.ts